import { aboutContent } from '@/mocks/siteData';

export default function Reputation() {
  return (
    <section className="py-10 md:py-14">
      <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-8 text-center">
        用户口碑
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {aboutContent.reputation.map((item) => (
          <div key={item.name} className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900">{item.name}</h3>
                <p className="text-xs text-foreground-500">{item.role}</p>
              </div>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
            <div className="flex items-center gap-0.5 mt-3">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-xs text-amber-400"></i>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}